/*
 * KIC Collection Filters: Lane KK' (2026-05-08)
 *
 * Mobile drawer open/close, body-scroll-lock, ESC handler, and a single
 * #kic-filter-status aria-live="polite" announcement region for chip
 * removal / Reset / swatch toggle (per amendment KK-A11y-3).
 *
 * Native <dialog>.showModal() handles focus-trap + ESC + inert-on-rest
 * automatically (per amendment KK-A11y-6); we only add body-scroll-lock,
 * the Show button click handler, and the live-region writers.
 *
 * No polyfill: Safari 15.4+ ships <dialog>; sub-15.4 traffic <2% per
 * StatCounter 2026 (KIC traffic analysis). Feature-detect graceful
 * no-trap fallback if sub-15.4 ever spikes (separate lane).
 *
 * JS-off: drawer is rendered as <dialog>; without JS it's hidden by
 * default (browser default). Filter pills in the desktop spine remain
 * accessible (the spine is server-rendered, JS-off works on desktop).
 * On mobile JS-off, the trigger button has fallback href="#kic-coll-v3"
 * scrolling users back to the inline spine. See spine for that fallback.
 */
(function () {
  'use strict';

  var dialog = document.getElementById('kic-coll-filter-dialog');
  var trigger = document.querySelector('[data-kic-filter-trigger]');
  var status = document.getElementById('kic-filter-status');

  if (!dialog || !trigger) return; // page didn't render the drawer (e.g. desktop only render)

  // Feature-detect native <dialog>.showModal: graceful no-op fallback.
  var hasDialogShowModal = typeof dialog.showModal === 'function';

  function announce(msg) {
    if (!status) return;
    // Clear then set on next tick to ensure SR re-announces identical strings.
    status.textContent = '';
    setTimeout(function () { status.textContent = msg; }, 50);
  }

  function lockBody() {
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
  }
  function unlockBody() {
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
  }

  function openDrawer() {
    if (hasDialogShowModal) {
      try { dialog.showModal(); } catch (e) { dialog.setAttribute('open', ''); }
    } else {
      dialog.setAttribute('open', '');
    }
    lockBody();
    trigger.setAttribute('aria-expanded', 'true');
    var pillCount = dialog.querySelectorAll('.kic-coll-v3__pill, .kic-coll-v3__swatch').length;
    announce('Filter dialog open. ' + pillCount + ' filters available.');
  }

  function closeDrawer() {
    if (hasDialogShowModal && dialog.open) {
      try { dialog.close(); } catch (e) { dialog.removeAttribute('open'); }
    } else {
      dialog.removeAttribute('open');
    }
    unlockBody();
    trigger.setAttribute('aria-expanded', 'false');
  }

  // Trigger
  trigger.addEventListener('click', function (e) {
    e.preventDefault();
    if (dialog.open) { closeDrawer(); } else { openDrawer(); }
  });

  // Close button
  var closeBtn = dialog.querySelector('[data-kic-filter-close]');
  if (closeBtn) closeBtn.addEventListener('click', function () { closeDrawer(); });

  // Native <dialog> close event (covers ESC + form-method=dialog + showModal close())
  dialog.addEventListener('close', function () { unlockBody(); trigger.setAttribute('aria-expanded', 'false'); });
  dialog.addEventListener('cancel', function () { /* ESC; close event will fire too */ });

  // Backdrop click: native <dialog> only registers clicks on the dialog itself, not the backdrop.
  // We compare click target rect: clicks outside the inner surface close.
  dialog.addEventListener('click', function (e) {
    if (e.target === dialog) { // user clicked on the ::backdrop pseudo or dialog padding
      var rect = dialog.getBoundingClientRect();
      var inSurface = e.clientX >= rect.left && e.clientX <= rect.right
                   && e.clientY >= rect.top  && e.clientY <= rect.bottom;
      // The outer dialog is full-viewport; only the bottom-sheet surface is .kic-coll-v3__drawer-surface.
      // If click is on dialog but NOT on surface, close.
      var surface = dialog.querySelector('.kic-coll-v3__drawer-surface');
      if (surface && !surface.contains(e.target)) { closeDrawer(); }
    }
  });

  // "Show (N pieces)" sticky bar: close drawer + scroll to grid.
  var showBtn = dialog.querySelector('[data-kic-filter-show]');
  if (showBtn) {
    showBtn.addEventListener('click', function (e) {
      // href is "#kic-coll-v3" so default scrolls; we just close drawer first.
      closeDrawer();
    });
  }

  // Chip-remove + Reset announcement hooks (event-delegated on document so
  // both desktop spine chips AND drawer chips route through the same path).
  // Chips are <a href> so default navigation handles the actual removal;
  // we announce BEFORE the page unloads.
  document.addEventListener('click', function (e) {
    var chip = e.target.closest('.kic-coll-v3__chip-remove');
    if (chip) {
      var label = chip.getAttribute('aria-label') || 'filter';
      // Strip leading "Remove " from "Remove Color: Blue" -> "Color: Blue"
      var stripped = label.replace(/^Remove\s+/, '');
      announce('Removed ' + stripped + '.');
      return;
    }
    var reset = e.target.closest('.kic-coll-v3__chip-reset, .kic-coll-v3__drawer-reset');
    if (reset) { announce('All filters cleared.'); return; }
  });
})();
